// "Was this tab hidden at any moment since the previous poll?" — sent as `d=1` with the
// genomgång, game and lesson-bar polls. A hidden tab polls slowly or not at all, so the next
// poll's wait is the student's absence, not the system's latency: Prestandavakten does not
// time it (lib/prestanda/elev-ser.ts). Browser only.

export interface DoldVakt {
  /** True if the tab is hidden or was hidden since the previous call; starts the next period. */
  ta(): boolean;
  stoppa(): void;
}

export function skapaDoldVakt(): DoldVakt {
  let dold = document.hidden;
  const vidAndring = () => {
    if (document.hidden) dold = true;
  };
  document.addEventListener("visibilitychange", vidAndring);
  return {
    ta() {
      const varDold = dold || document.hidden;
      dold = document.hidden;
      return varDold;
    },
    stoppa() {
      document.removeEventListener("visibilitychange", vidAndring);
    },
  };
}
